<div mat-dialog-title>
  <span>{{ 'IMPORT_DD.TITLE' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-info-message *ngIf="error" type="error">{{ error | translate }}</q9-info-message>

<mat-dialog-content>
  <q9-text-field
    [formControl]="filterControl"
    [label]="'POPUPS.QUICK_SEARCH' | translate"></q9-text-field>
  <mat-selection-list
    *ngIf="(mapsForImport | mapFilter: inputText | deletedMapFilter: filterByDeleted).length"
    #selectionList
    (selectionChange)="changeSelected($event)"
    [multiple]="false"
    class="selection-list">
    <mat-list-option
      *ngFor="let map of mapsForImport | mapFilter: inputText | deletedMapFilter: filterByDeleted"
      [value]="map"
      color="primary"
      role="option">
      <span [ngClass]="{'deleted-map': map?.state === 'deleted'}">
        {{ map.name | htmlEncoder: true }}
      </span>
    </mat-list-option>
  </mat-selection-list>
  <div
    *ngIf="!(mapsForImport | mapFilter: inputText | deletedMapFilter: filterByDeleted).length"
    class="selection-list">
    <q9-tab-placeholder class="empty-state">
      <mat-icon icon svgIcon="empty-filter"></mat-icon>
      <span text>
        {{ 'POPUPS.NOT_FOUND' | translate }}
      </span>
    </q9-tab-placeholder>
  </div>
  <mat-slide-toggle class="show-deleted-toggle" (change)="toggleDeletedMaps()">
    {{ 'POPUPS.SHOW_DELETED_MAPS' | translate }}
  </mat-slide-toggle>
  <q9-select
    *ngIf="selectedMap?.hasMasterVersion"
    [(ngModel)]="version"
    [label]="'IMPORT_DD.VERSION_TO_IMPORT_LABEL' | translate"
    class="version-select">
    <q9-option *ngFor="let importVersion of versionsToImport" [value]="importVersion.value">
      {{ importVersion.name | translate }}
    </q9-option>
  </q9-select>

  <div class="options-list" *ngIf="!!selectedMap && version !== 'master'">
    <span>{{ 'IMPORT_DD.SELECT_LINKS_TO_IMPORT' | translate }}</span>
    <q9-info-message type="warn">
      {{ 'IMPORT_DD.SELECT_LINKS_TO_IMPORT_WARNING' | translate }}
    </q9-info-message>
    <mat-checkbox
      *ngFor="let option of importOptions"
      [(ngModel)]="importOptionsValue[option.formControlName]"
      color="primary"
      [disableRipple]="true">
      {{ 'IMPORT_DD.IMPORT_' + option.text | translate }}
    </mat-checkbox>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button [isLoading]="isLoading()" (click)="import()">
    {{ 'IMPORT_DD.SUBMIT' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
